import { lazyImport } from "../../utility/lazyImport";
import {Navigate} from "react-router-dom";

const { Wallet } = lazyImport(() => import("../../features/wallet"), "Wallet");

const { PaymentResponse } = lazyImport(
  () => import("../../features/payment"),
  "PaymentResponse"
);

const { Financial } = lazyImport(
  () => import("../../features/financial"),
  "Financial"
);

const { CreditCardsTab } = lazyImport(
    () => import("@features/creditCard"),
    "CreditCardsTab"
);

const { TransactionsTab } = lazyImport(
    () => import("@features/transaction"),
    "TransactionsTab"
);

const { MoneyTransfer } = lazyImport(
    () => import("@features/financial"),
    "MoneyTransfer"
);

const { MoneyTransferDetails } = lazyImport(
    () => import("@features/financial"),
    "MoneyTransferDetails"
);

const { TransactionDetails } = lazyImport(
    () => import("@features/transaction"),
    "TransactionDetails"
);

const FinancialRoutes = [
  {
    path: "/wallet",
    element: <Wallet />,
    meta: {
      action: "read",
      resource: "wallet",
    },
  },
  {
    path: "/payment/response",
    element: <PaymentResponse />,
  },
  {
    path: "/financial",
    element: <Financial />,
    meta: {
      action: "read",
      resource: "financial",
    },
    children: [
      {
        path: "cards",
        element: <CreditCardsTab />,
      },
      {
        path: "transactions",
        element: <TransactionsTab />,
      },
      {
        path: "transactions/:id",
        element: <TransactionDetails />,
      },
      {
        path: "transfer",
        element: <MoneyTransfer />,
        children: [
          {
            path: ":userId",
            element: <MoneyTransferDetails />,
          },
]
      },
      {
        path: "*",
        element: <Navigate to={"transactions"} />,
      },
      {
        path: "",
        element: <Navigate to={"transactions"} />,
      },
    ],
  },
];

export default FinancialRoutes;
